import { armors } from "./armorTypes";
import { consumables } from "./consumableTypes";
import { furniture } from "./furnitureTypes";
import { ItemBreed } from "./Item";
import { shields } from "./shieldTypes";
import { weapons } from "./weaponTypes";

export const items = {
  ...armors,
  ...weapons,
  ...furniture,
  ...consumables,
  ...shields,
} as const;

export const ItemTypes = Object.entries(items).reduce((r, [key, value]) => {
  r[key as keyof typeof items] = new ItemBreed(key, value);
  return r;
}, {} as Record<keyof typeof items, ItemBreed>);
